import React from 'react';
import { Star, Heart } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ZodiacTheme } from './zodiacThemes';
interface FavoritesTabProps {
  theme: ZodiacTheme;
  onNavigate: (page: string) => void;
}
export function FavoritesTab({
  theme,
  onNavigate
}: FavoritesTabProps) {
  return <div className="space-y-6" data-id="element-15672">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6" data-id="element-15673">
        <div data-id="element-15674">
          <h2 className="text-xl sm:text-2xl font-bold text-slate-900" data-id="element-15675">
            Избранные астрологи
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-15676">3 астролога в избранном</p>
        </div>
        <Button variant="outline" onClick={() => onNavigate('astrologers')} data-id="element-15677">
          Найти ещё
        </Button>
      </div>

      <div className="space-y-3" data-id="element-15678">
        {[{
        name: 'Елена Смирнова',
        spec: 'Западная астрология • Натальная карта',
        rating: 4.9,
        reviews: 124,
        price: 'от 4 000 ₽',
        initials: 'ЕС',
        color: 'bg-indigo-100 text-indigo-700',
        online: true
      }, {
        name: 'Михаил Волков',
        spec: 'Ведическая астрология • Прогностика',
        rating: 5.0,
        reviews: 86,
        price: 'от 4 500 ₽',
        initials: 'МВ',
        color: 'bg-emerald-100 text-emerald-700',
        online: false
      }].map((astrologer, i) => <Card key={i} padding="md" data-id="element-15679">
            <div className="flex items-center gap-4" data-id="element-15680">
              <div className="relative flex-shrink-0" data-id="element-15681">
                <div className={`w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center text-lg font-bold ${astrologer.color}`} data-id="element-15682">
                  {astrologer.initials}
                </div>
                {astrologer.online && <div className="absolute bottom-0 right-0 w-3.5 h-3.5 bg-emerald-500 border-2 border-white rounded-full" data-id="element-15683" />}
              </div>
              <div className="flex-1 min-w-0" data-id="element-15684">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-15685">
                  <h3 className="font-bold text-slate-900 text-sm sm:text-base truncate" data-id="element-15686">
                    {astrologer.name}
                  </h3>
                  <div className="flex items-center gap-0.5 flex-shrink-0" data-id="element-15687">
                    <Star className="w-3.5 h-3.5 text-amber-400 fill-amber-400" data-id="element-15688" />
                    <span className="text-xs font-bold text-slate-900" data-id="element-15689">
                      {astrologer.rating}
                    </span>
                  </div>
                </div>
                <p className="text-xs sm:text-sm text-slate-500 truncate" data-id="element-15690">
                  {astrologer.spec}
                </p>
                <div className="text-xs font-medium text-indigo-600 mt-1" data-id="element-15691">
                  {astrologer.price}
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0" data-id="element-15692">
                <Button variant="primary" size="sm" className="hidden sm:flex text-xs" onClick={() => onNavigate('astrologer-profile')} data-id="element-15693">
                  Записаться
                </Button>
                <button className="p-1.5 text-rose-400 hover:text-rose-500 hover:bg-rose-50 rounded-lg transition-colors" title="Удалить из избранного" data-id="element-15694">
                  <Heart className="w-4 h-4 fill-current" data-id="element-15695" />
                </button>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}